// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/stream/v1/stream.proto (package social.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { CommenterType } from "../data/v1/comment_pb.js";
import { FrameType } from "../data/v1/image_pb.js";
import { FollowingActivity, Liker, ReplyInfo } from "../entity/v1/entity_pb.js";
import { VerifiedStatus } from "../../verified_badge/enum/v1/verified_status_pb.js";
import { ShareTradeInfo } from "../entity/v1/sharetrade_pb.js";

/**
 * @generated from message social.stream.v1.GetUploadTokenRequest
 */
export const GetUploadTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenRequest",
  () => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetUploadTokenResponse
 */
export const GetUploadTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: DataUploadTokenResponse },
  ],
);

/**
 * @generated from message social.stream.v1.DataUploadTokenResponse
 */
export const DataUploadTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DataUploadTokenResponse",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "aws_access_key_id", jsonName: "aws_access_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "success_action_redirect", jsonName: "success_action_redirect", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetUploadTokensRequest
 */
export const GetUploadTokensRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokensRequest",
  () => [
    { no: 1, name: "filenames", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetUploadTokensResponse
 */
export const GetUploadTokensResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokensResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetUploadTokenData },
  ],
);

/**
 * @generated from message social.stream.v1.GetUploadTokenData
 */
export const GetUploadTokenData = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenData",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tokens", kind: "message", T: GetUploadTokenInfo, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetUploadTokenInfo
 */
export const GetUploadTokenInfo = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenInfo",
  () => [
    { no: 1, name: "fields", kind: "message", T: GetUploadTokenInfo_Fields, repeated: true },
    { no: 2, name: "view_url", jsonName: "view_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetUploadTokenInfo.Fields
 */
export const GetUploadTokenInfo_Fields = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUploadTokenInfo.Fields",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "GetUploadTokenInfo_Fields"},
);

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessRequest
 */
export const ProcessUploadSuccessRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessRequest",
  () => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessResponse
 */
export const ProcessUploadSuccessResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: ProcessUploadSuccessData },
  ],
);

/**
 * @generated from message social.stream.v1.ProcessUploadSuccessData
 */
export const ProcessUploadSuccessData = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ProcessUploadSuccessData",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url_bit", jsonName: "url_bit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.WriteStreamRequest
 */
export const WriteStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.WriteStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target_symbol", jsonName: "target_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "target_duration", jsonName: "target_duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "polling_end", jsonName: "polling_end", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "polling_options", jsonName: "polling_options", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "polling_pin", jsonName: "polling_pin", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "share_portfolio", jsonName: "share_portfolio", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
);

/**
 * @generated from message social.stream.v1.WriteStreamResponse
 */
export const WriteStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.WriteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyStreamResponse
 */
export const ReplyStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ReplyStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.SaveNewsStreamResponse
 */
export const SaveNewsStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveNewsStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.SaveInsiderStreamResponse
 */
export const SaveInsiderStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveInsiderStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.SaveEmitenReportStreamResponse
 */
export const SaveEmitenReportStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveEmitenReportStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.UpdateStreamResponse
 */
export const UpdateStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UpdateStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.LikeStreamResponse
 */
export const LikeStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.LikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.UnlikeStreamResponse
 */
export const UnlikeStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnlikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.DislikeStreamResponse
 */
export const DislikeStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DislikeStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.SaveStreamResponse
 */
export const SaveStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.UnsaveStreamResponse
 */
export const UnsaveStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnsaveStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.ReportStreamResponse
 */
export const ReportStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ReportStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.FollowStreamResponse
 */
export const FollowStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.FollowStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.UnfollowStreamResponse
 */
export const UnfollowStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnfollowStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.PinStreamResponse
 */
export const PinStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.PinStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.UnpinStreamResponse
 */
export const UnpinStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnpinStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.ShareStreamResponse
 */
export const ShareStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ShareStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: PostStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.PostStreamResponse
 */
export const PostStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.PostStreamResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "lastid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 26, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "shorten_url", jsonName: "shorten_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "replyto", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "reply_content", jsonName: "reply_content", kind: "message", T: ReplyContent },
    { no: 42, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "target_price", jsonName: "target_price", kind: "message", T: TargetPrice, repeated: true },
    { no: 45, name: "analytics", kind: "message", T: Analytics },
    { no: 46, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 47, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 49, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 51, name: "polling", kind: "message", T: Polling, repeated: true },
    { no: 52, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 53, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 54, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 55, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 56, name: "verified_status", jsonName: "verified_status", kind: "enum", T: proto3.getEnumType(VerifiedStatus) },
  ],
);

/**
 * @generated from message social.stream.v1.Polling
 */
export const Polling = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.Polling",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "created_date", jsonName: "created_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start_date", jsonName: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "end_date", jsonName: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "question", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "options", kind: "message", T: PollingOptions, repeated: true },
    { no: 8, name: "expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "message_expired", jsonName: "message_expired", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "total_voters", jsonName: "total_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "my_vote", jsonName: "my_vote", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.ImagesData
 */
export const ImagesData = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ImagesData",
  () => [
    { no: 1, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "frame", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "frame_type", jsonName: "frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
);

/**
 * @generated from message social.stream.v1.PollingOptions
 */
export const PollingOptions = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.PollingOptions",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count_voters", jsonName: "count_voters", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.TargetPrice
 */
export const TargetPrice = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.TargetPrice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "voted", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "symbol2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tradeable", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_price", jsonName: "last_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "current_price", jsonName: "current_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "day_left", jsonName: "day_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "agree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "disagree", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "hit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.MaskHtml
 */
export const MaskHtml = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.MaskHtml",
  () => [
    { no: 1, name: "mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attr", kind: "message", T: MaskAttr },
  ],
);

/**
 * @generated from message social.stream.v1.MaskAttr
 */
export const MaskAttr = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.MaskAttr",
  () => [
    { no: 1, name: "class", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data_company", jsonName: "data_company", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_user", jsonName: "data_user", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_insider", jsonName: "data_insider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyContent
 */
export const ReplyContent = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ReplyContent",
  () => [
    { no: 1, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 14, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 15, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
  ],
);

/**
 * @generated from message social.stream.v1.Analytics
 */
export const Analytics = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.Analytics",
  () => [
    { no: 1, name: "impression", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "engagement", kind: "message", T: AnalyticsEngagement },
  ],
);

/**
 * @generated from message social.stream.v1.AnalyticsEngagement
 */
export const AnalyticsEngagement = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.AnalyticsEngagement",
  () => [
    { no: 1, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "reply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "share", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "profile_view", jsonName: "profile_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "sign_click", jsonName: "sign_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "media_click", jsonName: "media_click", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.Reports
 */
export const Reports = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.Reports",
  () => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ReplyStreamRequest
 */
export const ReplyStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ReplyStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "replyto", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.SaveNewsStreamRequest
 */
export const SaveNewsStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveNewsStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.SaveEmitenReportStreamRequest
 */
export const SaveEmitenReportStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveEmitenReportStreamRequest",
  () => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.SaveInsiderStreamRequest
 */
export const SaveInsiderStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveInsiderStreamRequest",
  () => [
    { no: 1, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 2, name: "content_mask", jsonName: "content_mask", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id_sender", jsonName: "user_id_sender", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.UpdateStreamRequest
 */
export const UpdateStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UpdateStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_symbol", jsonName: "target_symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target_price", jsonName: "target_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "target_duration", jsonName: "target_duration", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "sharefacebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "sharetwitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
);

/**
 * @generated from message social.stream.v1.LikeStreamRequest
 */
export const LikeStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.LikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.UnlikeStreamRequest
 */
export const UnlikeStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnlikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.DislikeStreamRequest
 */
export const DislikeStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DislikeStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.SaveStreamRequest
 */
export const SaveStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SaveStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.UnsaveStreamRequest
 */
export const UnsaveStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnsaveStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.PinStreamRequest
 */
export const PinStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.PinStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.UnpinStreamRequest
 */
export const UnpinStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnpinStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.ShareStreamRequest
 */
export const ShareStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ShareStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "facebook", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "twitter", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "stockbit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
);

/**
 * @generated from message social.stream.v1.ReportStreamRequest
 */
export const ReportStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ReportStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.FollowStreamRequest
 */
export const FollowStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.FollowStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.UnfollowStreamRequest
 */
export const UnfollowStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UnfollowStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.UpdateCommenterTypeRequest
 */
export const UpdateCommenterTypeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UpdateCommenterTypeRequest",
  () => [
    { no: 1, name: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
  ],
);

/**
 * @generated from message social.stream.v1.UpdateCommenterTypeResponse
 */
export const UpdateCommenterTypeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UpdateCommenterTypeResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteStreamRequest
 * @deprecated
 */
export const DeleteStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "send_email", jsonName: "send_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteStreamResponse
 * @deprecated
 */
export const DeleteStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteStreamsRequest
 */
export const DeleteStreamsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteStreamsRequest",
  () => [
    { no: 1, name: "user_id", jsonName: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "period", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "send_email", jsonName: "send_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteStreamsResponse
 */
export const DeleteStreamsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteStreamsResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.UndeleteStreamRequest
 */
export const UndeleteStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UndeleteStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.UndeleteStreamResponse
 */
export const UndeleteStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UndeleteStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteOwnStreamRequest
 */
export const DeleteOwnStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteOwnStreamRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteOwnStreamResponse
 */
export const DeleteOwnStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteOwnStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteOwnCommentRequest
 */
export const DeleteOwnCommentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteOwnCommentRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.DeleteOwnCommentResponse
 */
export const DeleteOwnCommentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.DeleteOwnCommentResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.AddVoteRequest
 */
export const AddVoteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.AddVoteRequest",
  () => [
    { no: 1, name: "tp_id", jsonName: "tp_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "agree", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.stream.v1.AddVoteResponse
 */
export const AddVoteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.AddVoteResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse },
  ],
);

/**
 * @generated from message social.stream.v1.ManipulateStreamRequest
 */
export const ManipulateStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ManipulateStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "like", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "dislike", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.ManipulateStreamResponse
 */
export const ManipulateStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.ManipulateStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetGenericStreamRequest
 */
export const GetGenericStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetGenericStreamRequest",
  () => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "beforetimestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "reporttype", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetUserStreamRequest
 */
export const GetUserStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUserStreamRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetSymbolStreamRequest
 */
export const GetSymbolStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetSymbolStreamRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "beforelastpost", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "lastpost", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "reporttype", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetGenericStreamResponse
 */
export const GetGenericStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetGenericStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetSymbolStreamResponse
 */
export const GetSymbolStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetSymbolStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetStreamResponse
 */
export const GetStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetStreamResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 25, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 26, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "polling", kind: "message", T: Polling, repeated: true },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "total_view", jsonName: "total_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "target_price", jsonName: "target_price", kind: "message", T: TargetPrice, repeated: true },
    { no: 43, name: "analytics", kind: "message", T: Analytics },
    { no: 44, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "last_reply_date", jsonName: "last_reply_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 46, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 47, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 49, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 50, name: "last_reply", jsonName: "last_reply", kind: "message", T: GetStreamResponse },
    { no: 51, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 52, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 53, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 54, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 55, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 56, name: "following_activity", jsonName: "following_activity", kind: "message", T: FollowingActivity },
    { no: 57, name: "sharetrade_info", jsonName: "sharetrade_info", kind: "message", T: ShareTradeInfo },
  ],
);

/**
 * @generated from message social.stream.v1.GetUserStreamResponse
 */
export const GetUserStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetUserStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetTrendingStreamResponse
 */
export const GetTrendingStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetTrendingStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetStreamOldResponse
 */
export const GetStreamOldResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetStreamOldResponse",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "titleurl", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_original", jsonName: "content_original", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_display", jsonName: "created_display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "userid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "is_author", jsonName: "is_author", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "official", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "ispro", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "user_priv", jsonName: "user_priv", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ispinned", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "trending", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 20, name: "replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "noreply", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "dislikes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 24, name: "reposted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "repostedfrom", kind: "message", T: GetStreamOldResponse },
    { no: 26, name: "liked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 27, name: "saved", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "images", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 29, name: "polling", kind: "message", T: Polling, repeated: true },
    { no: 30, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 31, name: "parent_postid", jsonName: "parent_postid", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "disliked", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 33, name: "follow", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "reports", kind: "message", T: Reports, repeated: true },
    { no: 35, name: "newsfeed_source", jsonName: "newsfeed_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "newsfeed_label", jsonName: "newsfeed_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "newsfeed_img", jsonName: "newsfeed_img", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 38, name: "linkpreview", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "total_view", jsonName: "total_view", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 40, name: "tradeshare", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "replyto", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "reply_content", jsonName: "reply_content", kind: "message", T: ReplyContent },
    { no: 43, name: "likers", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "total_share", jsonName: "total_share", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "target_price", jsonName: "target_price", kind: "message", T: TargetPrice, repeated: true },
    { no: 46, name: "analytics", kind: "message", T: Analytics },
    { no: 47, name: "isnews", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 48, name: "isreport", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 49, name: "topics", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 50, name: "ischart", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 51, name: "mask_html", jsonName: "mask_html", kind: "message", T: MaskHtml, repeated: true },
    { no: 52, name: "is_verified", jsonName: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 53, name: "images_data", jsonName: "images_data", kind: "message", T: ImagesData, repeated: true },
    { no: 54, name: "image_frame_type", jsonName: "image_frame_type", kind: "enum", T: proto3.getEnumType(FrameType) },
    { no: 55, name: "replying_to", jsonName: "replying_to", kind: "message", T: ReplyInfo },
    { no: 56, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 57, name: "is_unavailable", jsonName: "is_unavailable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 58, name: "following_activity", jsonName: "following_activity", kind: "message", T: FollowingActivity },
    { no: 59, name: "sharetrade_info", jsonName: "sharetrade_info", kind: "message", T: ShareTradeInfo },
    { no: 60, name: "verified_status", kind: "enum", T: proto3.getEnumType(VerifiedStatus) },
  ],
);

/**
 * @generated from message social.stream.v1.GetSentimentCompanyNewsRequest
 */
export const GetSentimentCompanyNewsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetSentimentCompanyNewsRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetSentimentCompanyNewsResponse
 */
export const GetSentimentCompanyNewsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetSentimentCompanyNewsResponse",
  () => [
    { no: 1, name: "data", kind: "message", T: Sentiment },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.Sentiment
 */
export const Sentiment = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.Sentiment",
  () => [
    { no: 1, name: "start_value", jsonName: "start_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_value", jsonName: "end_value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "periode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetConversationStreamRequest
 */
export const GetConversationStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamRequest",
  () => [
    { no: 1, name: "convo_parentid", jsonName: "convo_parentid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "streamid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetConversationStreamResponse
 */
export const GetConversationStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetConversationStreamModel },
  ],
);

/**
 * @generated from message social.stream.v1.GetConversationStreamModel
 */
export const GetConversationStreamModel = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetConversationStreamModel",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "next", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "prev", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "parent", kind: "message", T: GetStreamOldResponse },
    { no: 5, name: "replies", kind: "message", T: GetStreamOldResponse, repeated: true },
    { no: 6, name: "since_message", jsonName: "since_message", kind: "message", T: SinceMessage, repeated: true },
    { no: 7, name: "total_replies", jsonName: "total_replies", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "commenter_type", jsonName: "commenter_type", kind: "enum", T: proto3.getEnumType(CommenterType) },
    { no: 9, name: "is_commentable", jsonName: "is_commentable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.stream.v1.SinceMessage
 */
export const SinceMessage = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.SinceMessage",
  () => [
    { no: 1, name: "streamid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "change", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "pchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "company_name", jsonName: "company_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "latest", kind: "message", T: IfeedPrice },
  ],
);

/**
 * @generated from message social.stream.v1.IfeedPrice
 */
export const IfeedPrice = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.IfeedPrice",
  () => [
    { no: 1, name: "previous", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lastprice", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "change", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "volume", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "avgvolume", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamRequest
 */
export const GetMoreConversationStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "beforelastpost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamResponse
 */
export const GetMoreConversationStreamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetMoreConversationStreamModel },
  ],
);

/**
 * @generated from message social.stream.v1.GetMoreConversationStreamModel
 */
export const GetMoreConversationStreamModel = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetMoreConversationStreamModel",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "replies", kind: "message", T: GetStreamOldResponse, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetTrendingStreamRequest
 */
export const GetTrendingStreamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetTrendingStreamRequest",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetPinnedStreamUserRequest
 */
export const GetPinnedStreamUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamUserRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetPinnedStreamUserResponse
 */
export const GetPinnedStreamUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamUserResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.GetPinnedStreamCompanyRequest
 */
export const GetPinnedStreamCompanyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamCompanyRequest",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetPinnedStreamCompanyResponse
 */
export const GetPinnedStreamCompanyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetPinnedStreamCompanyResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.GetSingleStreamPostRequest
 */
export const GetSingleStreamPostRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetSingleStreamPostRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetSingleStreamPostResponse
 */
export const GetSingleStreamPostResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetSingleStreamPostResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetStreamOldResponse },
  ],
);

/**
 * @generated from message social.stream.v1.GetLikersRequest
 */
export const GetLikersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetLikersRequest",
  () => [
    { no: 1, name: "postid", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetLikersResponse
 */
export const GetLikersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetLikersResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetLikersData },
  ],
);

/**
 * @generated from message social.stream.v1.GetLikersData
 */
export const GetLikersData = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetLikersData",
  () => [
    { no: 1, name: "more", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "likers", kind: "message", T: Liker, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetAnnouncementRequest
 */
export const GetAnnouncementRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementRequest",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.GetAnnouncementResponse
 */
export const GetAnnouncementResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "message", T: GetAnnouncementData, repeated: true },
  ],
);

/**
 * @generated from message social.stream.v1.GetAnnouncementData
 */
export const GetAnnouncementData = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.GetAnnouncementData",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "company_id", jsonName: "company_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "posted_on", jsonName: "posted_on", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "headline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "attachment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "retrieved_on", jsonName: "retrieved_on", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "company_icon_url", jsonName: "company_icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message social.stream.v1.UntagTopicRequest
 */
export const UntagTopicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UntagTopicRequest",
  () => [
    { no: 1, name: "stream_id", jsonName: "stream_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message social.stream.v1.UntagTopicResponse
 */
export const UntagTopicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "social.stream.v1.UntagTopicResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

